import { formatValue } from 'comparador/technical-specs/utils'
import _ from 'lodash'
import { formatText } from 'Utilities'

const schema = {
    general: {
        SEGMENTO: {
            name: 'Tipo de Segmento'
        },
        origin_long: {
            name: 'País de origen'
        },
        TMOTOR: {
            name: 'Tipo de motor'
        },
        CILINDRADA: {
            name: 'Cilindrada (cc)'
        },
        COMBU: {
            name: 'Tipo de combustible'
        },
        TRANSMI: {
            name: 'Transmisión'
        },
        ENGRA: {
            name: 'Número de marchas (Cambios)'
        },
        DIRECC: {
            name: 'Tipo de dirección'
        },
        TRACCION: {
            name: 'Tipo de tracción'
        },
        CAIRB: {
            name: 'Cantidad de airbags'
        },
        TAMUP: {
            name: 'Tamaño de pantalla (“)'
        },
        TIPTA: {
            name: 'Tipo de Tapizado'
        },
        LARGOV: {
            name: 'Largo (m)'
        },
        ANCHOV: {
            name: 'Ancho (m)'
        },
        ALTOV: {
            name: 'Alto (m)'
        },
        CAPCU: {
            name: 'Capacidad del tanque de combustible (L)'
        },
        KMXLI: {
            name: 'Consumo medio de combustible (Km/l)'
        },
        BAUL: {
            name: 'Espacio de baúl (L)'
        }

    },
    seguridad: {
        CICEN: {
            name: 'Cierre centralizado'
        },
        ABS: {
            name: 'Sistema ABS'
        },
        SENSESTA: {
            name: 'Sensores de estacionamiento'
        },
        SREPFREN: {
            name: 'Sistema electrónico de reparto de frenada (EBD)'
        },
        AESTA: {
            name: 'Asistente de estacionamiento'
        },
        ISOFIX: {
            name: 'Ganchos Isofix'
        },
        ARRENPEN: {
            name: 'Asistente de arranque en pendiente'
        },
        DESCOLINA: {
            name: 'Control de descenso'
        },   
        AIRLAT: {
            name: 'Airbags laterales'
        },
        AIRCA: {
            name: 'Airbags conductor y acompañante'
        },
        AIRCOR: {
            name: 'Airbags de cortina'
        },
        AIRROD: {
            name: 'Airbags de rodilla'
        },
        APOST: {
            name: 'Airbags posteriores'
        },
        ASINT: {
            name: 'Airbag de cinturón'
        },
        APEAT: {
            name: 'Airbag de peatones'
        },
        AIRDO: {
            name: 'Airbags de doble etapa'
        },
        PRESNEUM: {
            name: 'Control de presión en neumáticos  (TPMS)'
        },
        CONTRAC: {
            name: 'Control de tracción (TC/TCS)'
        },
        ESTABELE: {
            name: 'Programa de estabilidad electrónica (ESP)'
        },
        DIFLI: {
            name: 'Diferencial de deslizamiento limitado (LSD)'
        },
        BLOQDIF: {
            name: 'Bloqueo de diferencial'
        },
        CCOND: {
            name: 'Control dinámico de conducción'
        },
        ASISTFREN: {
            name: 'Asistente de frenado (BA)'
        }
    },
    confort: {
        AA: {
            name: 'Aire acondicionado'
        },
        CLIMAT: {
            name: 'Climatizador'
        },
        ARRAN: {
            name: 'Arranque sin llave / Arranque con botón'
        },
        LDPRO: {
            name: 'Llave de proximidad'
        },
        SIGPS: {
            name: 'Sistema de navegación GPS'
        },
        COCRU: {
            name: 'Control de velocidad crucero'
        },
        TECHCOR: {
            name: 'Techo corredizo'
        },
        TECHPAN: {
            name: 'Techo vidriado panorámico'
        },
        ASIENTCLIMA: {
            name: 'Asientos climatizados'
        },
        HUDIS: {
            name: 'Heads Up Display (HUD)'
        },
        CDASI: {
            name: 'Capacidad de asientos'
        }
    },
    exterior: {
        NEDEL: {
            name: 'Neumáticos delanteros'
        },
        NETRA: {
            name: 'Neumáticos traseros'
        },
        LLANT: {
            name: 'Llantas'
        },
        ANTINIEBLA: {
            name: 'Antiniebla'
        },
        LUCDI: {
            name: 'Luces de circulación diurna (DRL)'
        },
        RIETE: {
            name: 'Rieles de techo'
        },
        JANTI: {
            name: 'Jaula antivuelco'
        },
        DDSUE: {
            name: 'Despeje del suelo (cm)'
        }
    },
    ayudasConduccion: {
        CDVPE: {
            name: 'Cámara de visión periférica'
        },
        FADEM: {
            name: 'Frenado autónomo de emergencia'
        },
        DDPEA: {
            name: 'Detección de peatones'
        },
        ACDCA: {
            name: 'Alerta cambio de carril'
        },
        ADPCI: {
            name: 'Alerta de punto ciego'
        },
        APLDC: {
            name: 'Asistencia para luz de carretera'
        },
        CCADA: {
            name: 'Control crucero adaptativo'
        },
        STNGO: {
            name: 'Stop & go'
        },
        DDSDT: {
            name: 'Detector de señales de tránsito'
        },
        DDFAT: {
            name: 'Detector de fatiga'
        },
        ADTCR: {
            name: 'Alerta de tráfico cruzado'
        },
        ADCFR: {
            name: 'Alerta de colisión frontal'
        },
        DDIDC: {
            name: 'Detector de inatención del conductor'
        },
        AAPSA: {
            name: 'Asistente activo para salida de aparcamiento'
        }
    }
}

const getSubSection = (carData, subSection = {}) => {
    return Object.keys(subSection).map(spec => {
        let formattedValue = formatValue(carData ? carData[spec] : null)

        return {
            ...subSection[spec],
            key: spec,
            value: formattedValue
        }
    })
}

const getTechSpecs = (carData) => {
    let techSpecs = {}
    Object.keys(schema).forEach(subSection => techSpecs[subSection] = getSubSection(carData, schema[subSection]))
    return techSpecs
}

export const filterEmptySpecs = (technicalSpecs) => {
    if (technicalSpecs.length === 0) return technicalSpecs
    let filteredSpecs = technicalSpecs

    Object.keys(schema).forEach(subSection => {
        let sectionLength = Object.keys(schema[subSection]).length

        for (let i = 0; i <= sectionLength - 1; i++) {
            if (!filteredSpecs.some(car => car[subSection][i]?.value !== '-')) {

                for (let vehicleSpecs of filteredSpecs) {
                    vehicleSpecs[subSection].splice(i, 1)
                }
                if (sectionLength > 0) sectionLength = sectionLength - 1
                i--
            }
        }
    })
    return filteredSpecs
}

export const filterSpecsBySearch = (technicalSpecs, inputValue) => {
    let filteredSections = []
    let filteredSpecs = []

    Object.keys(schema).forEach(subSection => {
        technicalSpecs.forEach((item, index) => {
                let filteredAux = item[subSection]
                inputValue.map(i => formatText.normalizedText(i)).forEach(iv => {
                    filteredAux = filteredAux.filter(car => {
                            const name = formatText.normalizedText(car.name.toString())
                            const value = formatText.normalizedText(car.value.toString())
                            return name?.includes(iv) || value?.includes(iv)
                        }
                    )
                })

                filteredSections[index] = {
                    ...filteredSections[index],
                    [subSection]: filteredAux.map(a => a.name)
                }
            }
        )
    })

    Object.keys(schema).forEach(subSection => {
        technicalSpecs.forEach((item, index) => {
            let filteredSection = []
            item[subSection].forEach(tsItem => {
                if (filteredSections.some(sectionItem => sectionItem[subSection].includes(tsItem.name)))
                    filteredSection.push(tsItem)
            })
            filteredSpecs[index] = {
                ...filteredSpecs[index],
                [subSection]: filteredSection
            }
        })
    })

    return filteredSpecs
}

const comparator = (val1, val2) => val1.name === val2.name && val1.value === val2.value

export const filterSpecsByCoincidences = (technicalSpecs) => {
    if (technicalSpecs.length < 2) return technicalSpecs
    let filteredSpecs = []

    Object.keys(schema).forEach(subSection => {
        const sectionsToCompare = technicalSpecs.map(item => item[subSection])
        filteredSpecs[subSection] = _.intersectionWith(...sectionsToCompare, comparator)
    })

    filteredSpecs = technicalSpecs.map(() => filteredSpecs)

    return filteredSpecs
}

export const filterSpecsByDifferences = (technicalSpecs) => {
    if (technicalSpecs.length < 2) return technicalSpecs
    let filteredSpecs
    let attributesNames = {}
    let differentAttributes = {}
    let differentAttributesNames = {}

    Object.keys(schema).forEach(subSection => {
        attributesNames[subSection] = []
        differentAttributesNames[subSection] = []

        technicalSpecs.forEach(carData => {
            carData[subSection].forEach(attribute => {
                const has = attributesNames[subSection].includes(attribute.name)
                if (!has) attributesNames[subSection] = [...attributesNames[subSection], attribute.name]
            })
        })
    })

    Object.keys(schema).forEach(subSection => {
        differentAttributes[subSection] = technicalSpecs.map((_item, index) => {
            const sectionsToCompare = technicalSpecs.map(item => item[subSection]).filter((_item2, index2) => index !== index2)
            const currentSection = technicalSpecs.map(item => item[subSection]).filter((_item2, index2) => index === index2)[0]
            return _.differenceWith(currentSection, ...sectionsToCompare, comparator)
        })

        differentAttributes[subSection].forEach(carDiffAttributes => {
            carDiffAttributes.forEach(attribute => {
                const has = differentAttributesNames[subSection].includes(attribute.name)
                if (!has) differentAttributesNames[subSection] = [...differentAttributesNames[subSection], attribute.name]
            })
        })
    })

    filteredSpecs = technicalSpecs.map(item => {
        let technicalSpecsSections = {}
        Object.keys(attributesNames).forEach(subSection => {
            technicalSpecsSections[subSection] = item[subSection].filter(ts => {
                return differentAttributesNames[subSection].includes(ts.name)
            })
        })
        return technicalSpecsSections
    })

    return filteredSpecs
}

export const getTechnicalSpecs = (cards) => {
    return filterEmptySpecs(cards.filter(vehicleData => vehicleData.vehicleDetails)
        .map(vehicleData => getTechSpecs(vehicleData?.vehicleDetails?.data?.vehicle)))
}
